<template>
  <div>
    <div class="d-flex justify-end mb-2">
      <vue-json-to-csv
        :json-data="exportRows"
        :labels="exportLabels"
        :csv-title="exportFilename"
        separator=";"
      >
        <v-btn text small color="deep-purple lighten-1">
          <v-icon left small>mdi-download</v-icon>
          {{ $t('surveys.export.button') }}
        </v-btn>
      </vue-json-to-csv>
    </div>
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-card class="pa-4 elevation-1 text-center">
          <div class="text-caption grey--text text-uppercase">
            {{ $t('studentSatisfaction.total_responses') }}
          </div>
          <div class="text-h3 font-weight-bold deep-purple--text">{{ results.n }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="pa-4 elevation-1 text-center">
          <div class="text-caption grey--text text-uppercase">
            {{ $t('studentSatisfaction.top_two_box') }}
          </div>
          <div class="text-h3 font-weight-bold green--text">
            {{ formatPct(results.topTwoBox) }}
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="pa-4 elevation-1 text-center">
          <div class="text-caption grey--text text-uppercase">
            {{ $t('studentSatisfaction.average_score') }}
          </div>
          <div class="text-h3 font-weight-bold amber--text text--darken-2">
            {{ formatScore(results.averageScore) }}
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="pa-4 elevation-1">
          <div class="text-caption grey--text text-uppercase mb-2">
            {{ $t('studentSatisfaction.keep_reading') }}
          </div>
          <div
            v-for="row in keepReadingRows"
            :key="row.key"
            class="mb-1"
          >
            <div class="d-flex justify-space-between text-caption">
              <span>{{ $t(`studentSatisfaction.keep_reading_${row.key}`) }}</span>
              <span class="grey--text">{{ formatPct(row.value) }}</span>
            </div>
            <v-progress-linear :value="row.value" :color="row.color" height="10" rounded />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv';

export default {
  name: 'SatisfactionKpis',
  components: { VueJsonToCsv },
  props: {
    results: { type: Object, required: true },
    campaignName: { type: String, default: '' },
  },
  computed: {
    keepReadingRows() {
      const kr = this.results.keepReading || {};
      return [
        { key: 'yes', value: kr.yesPercentage, color: 'green' },
        { key: 'maybe', value: kr.maybePercentage, color: 'amber darken-2' },
        { key: 'no', value: kr.noPercentage, color: 'red' },
      ];
    },
    exportRows() {
      const kr = this.results.keepReading || {};
      return [{
        n: this.results.n,
        topTwoBox: this.formatPct(this.results.topTwoBox),
        averageScore: this.formatScore(this.results.averageScore),
        keepReadingYes: this.formatPct(kr.yesPercentage),
        keepReadingMaybe: this.formatPct(kr.maybePercentage),
        keepReadingNo: this.formatPct(kr.noPercentage),
      }];
    },
    exportLabels() {
      return {
        n: { title: this.$t('studentSatisfaction.total_responses') },
        topTwoBox: { title: this.$t('studentSatisfaction.top_two_box') },
        averageScore: { title: this.$t('studentSatisfaction.average_score') },
        keepReadingYes: {
          title: `${this.$t('studentSatisfaction.keep_reading')} - ${this.$t('studentSatisfaction.keep_reading_yes')}`,
        },
        keepReadingMaybe: {
          title: `${this.$t('studentSatisfaction.keep_reading')} - ${this.$t('studentSatisfaction.keep_reading_maybe')}`,
        },
        keepReadingNo: {
          title: `${this.$t('studentSatisfaction.keep_reading')} - ${this.$t('studentSatisfaction.keep_reading_no')}`,
        },
      };
    },
    exportFilename() {
      return `kpis_${this.campaignName}_${new Date().toISOString().slice(0, 10)}`;
    },
  },
  methods: {
    formatPct(value) {
      return `${Math.round(value || 0)}%`;
    },
    formatScore(value) {
      return Number(value || 0).toFixed(1);
    },
  },
};
</script>
